// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1s3Hk","inner":"Footer_inner__1Kz9q","nextIcon":"Footer_nextIcon__1WMkq","innerLeft":"Footer_innerLeft__2yjvg"};